Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgNullable = exports.Arg = exports.compileFieldArgs = void 0;
const registry_1 = require("./registry");
var compiler_1 = require("./compiler");
Object.defineProperty(exports, "compileFieldArgs", { enumerable: true, get: function () { return compiler_1.compileFieldArgs; } });
const options_1 = require("./options");
function Arg(options = {}) {
    return (target, fieldName, argIndex) => {
        registry_1.argRegistry.set(target.constructor, [fieldName, argIndex], {
            ...options_1.defaultArgOptions,
            ...options,
            argIndex
        });
    };
}
exports.Arg = Arg;
/**
 * a shorthand for @Arg({isNullable: true})
 */
function ArgNullable(options = {}) {
    return Arg({ ...options, isNullable: true });
}
exports.ArgNullable = ArgNullable;
//# sourceMappingURL=ArgDecorators.js.map